import styled from '@emotion/styled'
import { Product } from '@news-mono/web-common'
import {
    breakpoint,
    breakWords,
    calcRem,
    colors,
    fonts,
    themedValue,
} from '../..'
import { CardMedia } from '../CardMedia/CardMedia'
import { CardText } from '../CardText/CardText'
import { StyledKicker } from '../Kicker/Kicker.styled'
export interface StyledBauhausVideoCardProps {
    isCurrentlyPlaying?: boolean | false
}

export const StyledBauhausVideoCard = styled(
    'div',
)<StyledBauhausVideoCardProps>(({ theme, isCurrentlyPlaying }) => ({
    ...breakWords,
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 'initial',
    alignItems: 'stretch',
    borderRadius:
        theme.kind === Product.TheWest ? '4px' : theme.radius?.sm ?? '1px',
    lineHeight: '19px',
    height: themedValue(theme, {
        thewest: calcRem(105),
        perthnow: calcRem(110), //set this to 136 if we're doing play now lable
        sevennews: calcRem(128),
        fallback: undefined,
    }),
    boxShadow: themedValue(theme, {
        thewest: `0 0px 2px rgba(0,0,0,0.25)`,
        perthnow: `0 0px 2px rgba(0,0,0,0.25)`,
        sevennews: `0 0px 7px rgba(0,0,0,0.25)`,
        fallback: undefined,
    }),
    border: isCurrentlyPlaying
        ? themedValue(theme, {
              thewest: `1.3px solid ${colors.thewest.westblue}`,
              perthnow: `1px solid ${colors.perthnow.pinkThulite}`,
              sevennews: `1px solid ${theme.sectionValues.primaryColor}`,
              fallback: undefined,
          })
        : 'unset',
    borderBottom:
        isCurrentlyPlaying && theme.kind === 'thewest'
            ? `4px solid ${colors.thewest.westblue}`
            : undefined,
    cursor: 'pointer',
    marginBottom: theme.kind === 'thewest' ? calcRem(5) : 0,
    [breakpoint('md')]: {
        marginBottom: theme.kind === 'thewest' ? calcRem(10) : calcRem(15),
        height: themedValue(theme, {
            thewest: calcRem(105),
            sevennews: 'unset',
            fallback: undefined,
        }),
    },
}))

export interface StyledBauhausVideoCardTextMediaProps {
    isCurrentlyPlaying?: boolean | false
}
export const StyledBauhausVideoCardTextMedia = styled(
    'div',
)<StyledBauhausVideoCardTextMediaProps>(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: theme.kind === 'thewest' ? calcRem(8) : calcRem(15),
    paddingBottom:
        theme.kind === 'thewest' || theme.kind === 'sevennews' ? undefined : 0,
    flex: 1,
}))

export const StyledBauhausVideoCardMediaWrapper = styled(
    'div',
)<StyledBauhausVideoCardTextMediaProps>(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
}))
export interface StyledBauhausVideoCardMediaProps {}
export const StyledBauhausVideoCardMedia = styled(
    CardMedia,
)<StyledBauhausVideoCardMediaProps>(({ theme }) => ({
    flex: 2,
    margin: theme.kind === 'thewest' ? 0 : undefined,
    marginBottom: theme.kind === 'sevennews' ? 0 : undefined,
}))

export const StyledBauhausVideoCardTextWrapper = styled('div')(({ theme }) => ({
    display: 'block',
    flexWrap: 'wrap',
    flex: 3,
    [`${StyledKicker}`]: {
        color:
            theme.kind === 'sevennews'
                ? theme.sectionValues.primaryColor
                : undefined,
    },
}))

export const StyledBauhausVideoCardText = styled(
    CardText,
)<StyledBauhausVideoCardTextMediaProps>(({ theme, isCurrentlyPlaying }) => ({
    display: 'flex',
    flexDirection: 'row-reverse',
    flex: 3,
    marginRight: calcRem(5),
    paddingRight: theme.kind === Product.SevenNews ? calcRem(15) : calcRem(12),
    '& [class*="Card-Headline"]': {
        color: 'red',
        fontSize: calcRem(14),
        lineHeight: '17px',
        fontFamily: themedValue(theme, {
            thewest: undefined,
            perthnow: theme.fonts.sansSerifCond,
            sevennews: fonts.sevennews.sansSerif,
            fallback: undefined,
        }),
        [breakpoint('md')]: {
            fontSize: calcRem(16),
            marginBottom: theme.kind === 'thewest' ? 0 : calcRem(10),
        },
    },
    '& [class*="StyledHeadlineText"]': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        lineClamp: 3,
        color:
            isCurrentlyPlaying && theme.kind === 'thewest'
                ? colors.thewest.westblue
                : undefined,
        '-webkit-line-clamp': theme.kind === 'thewest' ? '4' : '3',
        '-webkit-box-orient': 'vertical',
        [breakpoint('md')]: {
            '-webkit-line-clamp': '3',
        },
    },
}))
